import "./job-position.component.scss";
import { useContext, useEffect, useRef, useState } from "react";
import JOBTITLE_JSON from "../../../assets/json/job-role.json";
import { Button } from "react-bootstrap";
import { getAllSkills, getJD } from "../../../services/api.service";
import AI_STAR from "../../../assets/images/ai-icon.png";
import { Autocomplete, Box, Checkbox, Chip, Divider, FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, OutlinedInput, Radio, RadioGroup, Select, SelectChangeEvent, Slider, TextField, Typography } from "@mui/material";
import ScoutConnectService from "../../../services/hr9/hr9.services";
import { CompanyIndustryModel } from "../../../model/company-industry.model";
import { JobRoleListModel } from "../../../model/company-job-role.model";
import { GenerateJdModel } from "../../../model/generate-jd.model";
import { CandidateRequireModel, JobPosition } from "../../../model/questions-summary.model";
import { useLanguage } from "../../../contexts/language.context";
import SOFT_SKILL_JSON from "../../../assets/json/soft-skills.json";
import MOCK_JD from "../../../assets/json/mock-jd.json";
import ChipSelector from "../../../shared/chip-select-ui/chip-select-ui.component";
import RoundedOutlinedContainer from "../../../shared/round-textfield/round-textfield.shared";
import TONE_JSON from "../../../assets/json/tone-value.json";
import tokenService from "../../../services/token.service";
import { ProviderContext } from "../../../contexts/provider.context";
import ProfileSCModel from "../../../model/profile.model";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faChevronDown, faCircleXmark, faXmark, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
interface JobPositionProps {
    position: JobPosition
    onSubmit(value: any): void
    isSubmitStep1: boolean
    setSubmitStep(boolean: boolean): void
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MAX_VISIBLE_ITEMS = 8; // Number of items to display in dropdown
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
const JobPositionComponent: React.FC<JobPositionProps> = ({ onSubmit, position, isSubmitStep1, setSubmitStep }) => {
    const { profileModel }: any = useContext(ProviderContext);
    const [profileMod, setProfileMod] = useState<ProfileSCModel>(profileModel);
    const { t } = useLanguage();
    const [autocompleteJobTitle, setAutocompleteJobTitle] = useState<String[]>([]);
    const [name, setName] = useState("");
    const [jobTitle, setJobTitle] = useState(position.job_title);
    const [industry, setIndustry] = useState(position.default.industry);
    const [jobExp, setJobExp] = useState<number[]>(position.default.exp || [5, 7]);
    const [jobSalary, setJobSalary] = useState<number[]>(position.default.salary || [25000, 35000]);
    const [jobDescription, setJobDescription] = useState(position.job_advance.job_description);
    const [jobQualification, setJobQualification] = useState(position.job_advance.job_qualification);
    const typeaheadRef = useRef<any>(null);
    const [allSkills, setAllSkills] = useState<string[]>(position.job_advance.job_skills || []);
    const [industryList, setIndustryList] = useState<String[]>([]);
    const [aiGenerating, setAIGenerating] = useState(false);
    const [level, setLevel] = useState(position.job_level || "Entry-Level");
    const [jobWorkType, setJobWorkType] = useState(position.job_work_type || "Onsite");
    const [departmentList, setDepartmentList] = useState<String[]>([]);
    const [department, setDepartment] = useState(position.default.department);
    const [departmentValue, setDepartmentValue] = useState("");
    const [industryValue, setIndustryValue] = useState("");
    const allSoftSkills = SOFT_SKILL_JSON;
    const [jobEmployment, setJobEmployment] = useState(position.job_employment || "Full Time");
    const [tone, setTone] = useState("Professional");
    const [interviewTime, setInterviewTime] = useState(30);
    const [isSubmitting, setIsSubmitting] = useState(false);
    // complete_report_slots was removed (company-level credits)
    const [isError, setIsError] = useState({
        name: false,
        jobTitle: false,
        tone: false,
        interviewTime: false,
        language: false,
        hardware: false,
        jobExp: false,
        jobLevel: false,
        jobDescription: false,
        softSkill: false,
        hardSkill: false
    })

    const [softSkillInput, setSoftSkillInput] = useState("");
    const [selectedSoftSkills, setSelectedSoftSkills] = useState<string[]>(position.job_advance.soft_skills || []);

    const [hardSkillInput, setHardSkillInput] = useState("");
    const [selectedHardSkills, setSelectedHardSkills] = useState<string[]>(position.job_advance.hard_skills || []);

    const [toolTechInput, setToolTechInput] = useState("");
    const [selectedToolTech, setSelectedToolTech] = useState<string[]>(position.job_advance.tool_and_technology || []);

    const [leaderShipInput, setleaderShipInput] = useState("");
    const [selectedLeaderShip, setSelectedLeaderShip] = useState<string[]>(position.job_advance.leadership_expectation || []);

    const [companyCulture, setCompanyCultureInput] = useState("");
    const [selectedCompCulture, setSelectedCompCulture] = useState<string[]>(position.job_advance.company_culture || []);
    const [candidateRequire, setCandidateRequire] = useState<CandidateRequireModel>(position.candidate_require || {
        email: true,
        firstname: true,
        lastname: true,
        resume: true
    });

    const [langTh, setLangTh] = useState(true);
    const [langEn, setLangEn] = useState(true);
    const [requireCamera, setRequireCamera] = useState(
        position.hardware_require?.is_camera ?? true
    );
    const [requireMic, setRequireMic] = useState(
        position.hardware_require?.is_mic ?? true
    );
    const [recordVideo, setRecordVideo] = useState(
        position.hardware_require?.record_video ?? false
    );
    const [hardSkillQuestionType, setHardSkillQuestionType] = useState("voice");
    const [publicLinkType, setPublicLinkType] = useState(false);
    const [generateJDMod, setGenerateJD] = useState<GenerateJdModel>();
    const jobEXPRange = [
        {
            value: 0,
            label: 'ไม่มีประสบการณ์',
        },

        {
            value: 10,
            label: '10 ปีขึ้นไป',
        },
    ];
    const salaryRange = [
        {
            value: 15000,
            label: 'น้อยกว่า 15,000 บาท',
        },

        {
            value: 100000,
            label: 'มากกว่า 100,000 บาท',
        },
    ];
    const handleChangeExp = (event: Event, newValue: number | number[]) => {
        setJobExp(newValue as number[]);
    };
    const handleChangeSalary = (event: Event, newValue: number | number[]) => {
        setJobSalary(newValue as number[]);
    };

    useEffect(() => {
        if (isSubmitStep1) {
            handleSubmit();
        }
    }, [isSubmitStep1])
    useEffect(() => {
        const options = JOBTITLE_JSON.flatMap((category) => [
            { id: category.id, name: category.name, nameEn: category.nameEn },
            ...(category.subRole || []),
        ]);

        // Map and filter out duplicates using Set
        const items = Array.from(new Set(options.map((item) => `${item.name} (${item.nameEn})`)));

        setAutocompleteJobTitle(items);
        getIndustryList();
        getJobRoleList();
        setName(position.name);
    }, []);
    useEffect(() => {
        loadAllSkill();
    }, []);

    const loadAllSkill = async () => {
        const res = await getAllSkills();
        if (res) {
            setAllSkills(res.skills);
        }
    };
    const handleIndustryChange = (selectedValue) => {
        if (selectedValue) {
            setIndustry(selectedValue); // Fix: Set the selected value directly
            setIndustryValue(selectedValue);
        } else {
            setIndustry(null);
            setIndustryValue("");
        }
    };
    const handleDepartmentChange = (selectedValue) => {
        if (selectedValue) {
            setDepartment(selectedValue); // Fix: Set the selected value directly
            setDepartmentValue(selectedValue);
        } else {
            setDepartment(null);
            setDepartmentValue("");
        }
    };
    const handleJobRoleChange = (event, value) => {
        console.log(value);
        setIsError(prev => ({ ...prev, jobTitle: false }))
        setJobTitle(value);
    };

    const handleInputChange = (event: any, field: string) => {
        const value = event.target.value;
        console.log(value);
        switch (field) {
            case 'jobDescription': {
                setIsError(prev => ({ ...prev, jobDescription: false }))
                setJobDescription(value); break;
            }
            case 'jobQualification': setJobQualification(value); break;
            case 'name':
                {
                    setIsError(prev => ({ ...prev, name: false }))
                    setName(value);
                    break;
                }
            default: break;
        }
    };



    const formatExpRange = (range: number[]): string => {
        if (range[0] === range[1]) {
            return `${range[0].toLocaleString()} ปี`; // Show only one value if both are the same
        }
        return `${range[0].toLocaleString()} ปี - ${range[1].toLocaleString()} ปี`;
    };
    const formatSalaryRange = (range: number[]): string => {
        if (range[0] === range[1]) {
            return `${range[0].toLocaleString()} บาท`; // Show only one value if both are the same
        }
        return `${range[0].toLocaleString()} บาท - ${range[1].toLocaleString()} บาท`;
    };

    const parseSalaryRange = (formatted: string): number[] => {
        const cleaned = formatted.replace(" บาท", "").split(" - ").map(value => Number(value.replace(/,/g, "")));
        return cleaned.length === 1 ? [cleaned[0], cleaned[0]] : cleaned;
    };

    const parseExpRange = (formatted: string): number[] => {
        const cleaned = formatted.replace(" ปี", "").split(" - ").map(value => Number(value.replace(/,/g, "")));
        return cleaned.length === 1 ? [cleaned[0], cleaned[0]] : cleaned;
    };

    const getIndustryList = () => {
        ScoutConnectService.getIndustry().then((res) => {
            console.log(res);
            if (res.data) {
                const result = res.data as CompanyIndustryModel[];
                const industryString = result.map(item => item.nameTh);
                setIndustryList(industryString as String[]);
            }
        })
    }

    const getJobRoleList = () => {
        ScoutConnectService.getJobRoles().then((res) => {
            console.log(res);
            if (res.data) {
                const result = res.data as JobRoleListModel[];
                const departMentString = result.map(item => item.name);
                setDepartmentList(departMentString);
            }
        })
    }

    const resetError = () => {
        const errorMod = { ...isError };
        errorMod.name = false;
        errorMod.jobTitle = false;
        errorMod.tone = false;
        errorMod.interviewTime = false;
        errorMod.language = false;
        errorMod.hardware = false;
        errorMod.jobExp = false;
        errorMod.jobLevel = false;
        errorMod.jobDescription = false;
        errorMod.softSkill = false;
        errorMod.hardSkill = false;
        setIsError(errorMod);
    }

    useEffect(() => {
        console.log(isError);
    }, [isError])
    const handleSubmit = () => {
        console.log("Submit step 1");
        setIsSubmitting(true);
        // Prepare values
        const jobSalaryValue = formatSalaryRange(jobSalary);
        const expValue = formatExpRange(jobExp);
        const languageInterview: string[] = [];
        if (langEn) languageInterview.push("en");
        if (langTh) languageInterview.push("th");
        const hasRequiredFields = Boolean(
            name &&
            level &&
            jobDescription &&
            tone &&
            interviewTime &&
            jobTitle &&
            languageInterview.length > 0 &&
            selectedSoftSkills.length > 0 &&
            selectedHardSkills.length > 0
        );
        // Validate required fields
        if (!hasRequiredFields) {
            const errorMod = { ...isError };
            if (!name) errorMod.name = true
            if (!jobDescription) errorMod.jobDescription = true
            if (!tone) errorMod.tone = true
            if (languageInterview.length === 0) errorMod.language = true
            if (!interviewTime) errorMod.interviewTime = true
            if (!jobTitle) errorMod.jobTitle = true
            if (!level) errorMod.jobLevel = true
            if (selectedSoftSkills.length === 0) errorMod.softSkill = true
            if (selectedHardSkills.length === 0) errorMod.hardSkill = true
            console.log(errorMod);
            setIsError(errorMod);
            setSubmitStep(false);
        } else {
            if (profileMod) {
                console.log(profileMod);
                const companyDetail = profileMod.companyManageResponses.filter((item) => item.companyUuid == tokenService.getHR9CompanyUUID());
                console.log(companyDetail);
                const formData: JobPosition = {
                    name: name,
                    hardware_require: {
                        is_camera: requireCamera,
                        is_mic: requireMic,
                        record_video: recordVideo
                    },
                    interview_language: languageInterview,
                    interview_time: interviewTime,
                    tone: {
                        title: tone,
                        description: TONE_JSON.find(item => item.tone == tone)?.description_en || ""
                    },
                    company_id: companyDetail[0].companyUuid,
                    company_name: companyDetail[0].companyName,
                    company_logo: companyDetail[0].companyLogoImageUrl,
                    job_title: jobTitle,
                    job_exp: expValue,
                    job_salary: jobSalaryValue,
                    job_level: level,
                    job_department: departmentValue,
                    job_work_type: jobWorkType,
                    job_industry: industryValue,
                    job_employment: jobEmployment,
                    question_type: hardSkillQuestionType,
                    job_advance: {
                        job_description: jobDescription,
                        job_qualification: jobQualification,
                        soft_skills: selectedSoftSkills,
                        hard_skills: selectedHardSkills,
                        tool_and_technology: selectedToolTech,
                        leadership_expectation: selectedLeaderShip,
                        company_culture: selectedCompCulture
                    },
                    default: {
                        department: department,
                        industry: industry,
                        exp: jobExp,
                        salary: jobSalary
                    },
                    candidate_require: candidateRequire
                };

                console.log("Form Submitted Successfully:", formData);

                if (typeaheadRef.current) {
                    typeaheadRef.current.clear(); // Clear selection
                    typeaheadRef.current.blur();  // Close dropdown
                }

                onSubmit({ job_position: formData });
            }
        }


    };
    const handleLanguageChange = (value, lang) => {
        if (lang == "en") {
            setLangEn(value)
        } else {
            setLangTh(value)
        }
    };
    const handleHardSkillQuestionChange = (value) => {
        if (value == "voice") {
            setHardSkillQuestionType(value)
        } else if (value == "multiple_choice") {
            setHardSkillQuestionType(value)
        }
        else {
            setHardSkillQuestionType(value)
        }
    };
    const handlePublicLinkChange = (value) => {
        setPublicLinkType(value);
        console.log(value);
    };
    const handleHardwareChange = (value, hardware) => {
        if (hardware == "camera") {
            setRequireCamera(value);
            if (!value) setRecordVideo(false);
        } else if (hardware == "mic") {
            setRequireMic(value);
        } else if (hardware == "record_video") {
            setRecordVideo(value);
            if (value) setRequireCamera(true);
        }
    };
    const handleChangeSoftSkill = (event: SelectChangeEvent<typeof selectedSoftSkills>) => {
        const {
            target: { value },
        } = event;
        setSelectedSoftSkills(  // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,);
    };
    const onHandleSkill = (value, field) => {
        if (field == "soft skill" && value.length > 0) {
            setSoftSkillInput(value);
        } else if (field == "tool tech" && value.length > 0) {
            setToolTechInput(value)
        } else if (field == "leadership" && value.length > 0) {
            setleaderShipInput(value)
        } else if (field == "company culture" && value.length > 0) {
            setCompanyCultureInput(value)
        } else if (field == "hard skill" && value.length > 0) {
            setHardSkillInput(value)
        }
    }
    const onSelectSkill = (field) => {
        if (field == "soft skill") {
            setIsError(prev => ({ ...prev, softSkill: false }))
            setSelectedSoftSkills(prev => [...prev, softSkillInput]);
            setSoftSkillInput("");
        } else if (field == "tool tech") {
            setSelectedToolTech(prev => [...prev, toolTechInput]);
            setToolTechInput("")
        } else if (field == "leadership") {
            setSelectedLeaderShip(prev => [...prev, leaderShipInput]);
            setleaderShipInput("")
        } else if (field == "company culture") {
            setSelectedCompCulture(prev => [...prev, companyCulture]);
            setCompanyCultureInput("")
        } else if (field == "hard skill") {
            setIsError(prev => ({ ...prev, hardSkill: false }))
            setSelectedHardSkills(prev => [...prev, hardSkillInput]);
            setHardSkillInput("")
        }


    };

    const handleChangeLevel = (value) => {
        setLevel(value);
    }
    const handleChangeWorkType = (value) => {
        setJobWorkType(value);
    }
    const handleChangeEmploymentType = (value) => {
        setJobEmployment(value);
    }

    const handleChangeTone = (value) => {
        setIsError(prev => ({ ...prev, tone: false }))
        setTone(value);
    }

    const handleChangeInterviewTime = (value) => {
        setIsError(prev => ({ ...prev, interviewTime: false }))
        setInterviewTime(value);
    }
    const generateJD = () => {

        if (jobTitle) {
            setAIGenerating(true);
            const jobSalaryValue = jobSalary ? formatSalaryRange(jobSalary) : "";
            const expValue = jobExp ? formatExpRange(jobExp) : "";
            const departmentValue = department ? department : "";
            const industryValue = industry ? industry : "";
            const result = MOCK_JD as GenerateJdModel;
            // setGenerateJD(result);
            // setJobDescription(result.job_description);
            // setJobQualification(result.job_qualification);
            // setSelectedSoftSkills(result.soft_skills);
            // setSelectedHardSkills(result.hard_skills);
            // setSelectedToolTech(result.tool_and_technology);
            // setSelectedLeaderShip(result.leadership_expectation);
            // setSelectedCompCulture(result.company_culture);
            // setAIGenerating(false);
            getJD(jobTitle, expValue, jobSalaryValue, level, industryValue, departmentValue, jobWorkType, jobEmployment).then((res) => {
                if (res.data.is_success) {
                    console.log(res.data);
                    const result = res.data.data as GenerateJdModel;
                    if (result.soft_skills && result.soft_skills.length > 0) {
                        setSelectedSoftSkills(result.soft_skills);
                        setIsError(prev => ({ ...prev, softSkill: false }))
                    }
                    if (result.hard_skills && result.hard_skills.length > 0) {
                        setSelectedHardSkills(result.hard_skills);
                        setIsError(prev => ({ ...prev, hardSkill: false }))
                    }

                    if (result.job_description) {
                        setJobDescription(result.job_description);
                        setIsError(prev => ({ ...prev, jobDescription: false }))
                    }
                    setGenerateJD(result);
                    setJobQualification(result.job_qualification);
                    setSelectedToolTech(result.tool_and_technology);
                    setSelectedLeaderShip(result.leadership_expectation);
                    setSelectedCompCulture(result.company_culture);
                    setAIGenerating(false);
                } else {
                    setAIGenerating(false)
                }
            })
        }
    }
    function valuetextSalary(value: number) {
        return `${value}`;
    }
    function valuetext(value: number) {
        return `${value}`;
    }

    const handleChipChange = (value, field) => {
        if (field == "soft_skill") {
            setIsError(prev => ({ ...prev, softSkill: false }))
            setSelectedSoftSkills(value);
        } else if (field == "hard_skill") {
            setIsError(prev => ({ ...prev, hardSkill: false }))
            setSelectedHardSkills(value);
        } else if (field == "tech_tool") {
            setSelectedToolTech(value);
        } else if (field == "leader") {
            setSelectedLeaderShip(value);
        } else if (field == "culture") {
            setSelectedCompCulture(value);
        }
    }

    const handleCandidateRequireChange = (value, field) => {

        if (field == "email") {
            setCandidateRequire(prev => ({ ...prev, email: value }));
        } else if (field == "firstname") {
            setCandidateRequire(prev => ({ ...prev, firstname: value }));
        } else if (field == "lastname") {
            setCandidateRequire(prev => ({ ...prev, lastname: value }));
        } else if (field == "resume") {
            setCandidateRequire(prev => ({ ...prev, resume: value }));
        }
    }





    return (
        <div className="job-position-control">
            <div className="border-std job-position-form-control">
                <div className="job-position-form-title-control">
                    <div className="job-position-dot-title"></div>
                    <span className="job-position-form-title">รายละเอียดชุดคำถาม</span>
                </div>
                <div className="job-position-item-flex">
                    <FormControl className={isSubmitting && isError.name ? "input-std job-position-item-input-field input-error" : "input-std job-position-item-input-field"} fullWidth>
                        <TextField id="outlined-basic" label="ใส่ชื่อของชุดคำถามสัมภาษณ์"
                            variant="outlined"
                            value={name}
                            onChange={(e) => handleInputChange(e, 'name')} />
                    </FormControl>

                    <div className="premium-flex">
                        <Button className="button-std tag-premium" variant="info"><img src={AI_STAR} className="icon"></img>Premium Only</Button>
                        <div className="job-position-item-grid">

                            <div className="job-position-item">
                                <FormControl className={isSubmitting && isError.tone ? "input-std input-error" : "input-std"} fullWidth>
                                    <InputLabel id="demo-simple-select-label">Tone ของคำถาม</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={tone}
                                        label="Tone ของคำถาม"
                                        className="job-position-item-input-field"
                                        defaultValue={tone}
                                        disabled
                                        onChange={(e) => handleChangeTone(e.target.value)}
                                    >
                                        {
                                            TONE_JSON.map((item) => {
                                                return (
                                                    <MenuItem value={item.tone} key={item.tone} >{item.tone}</MenuItem>
                                                )
                                            })
                                        }

                                    </Select>
                                </FormControl>
                            </div>
                            <div className="job-position-item">
                                <FormControl className={isSubmitting && isError.interviewTime ? "input-std input-error" : "input-std"} fullWidth>
                                    <InputLabel id="demo-simple-select-label">เวลาในการสัมภาษณ์</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label-2"
                                        id="demo-simple-select-2"
                                        value={interviewTime}
                                        label="เวลาในการสัมภาษณ์"
                                        className="job-position-item-input-field"
                                        defaultValue={interviewTime}
                                        disabled
                                        onChange={(e) => handleChangeInterviewTime(e.target.value)}
                                    >
                                        <MenuItem value={30}>30 นาที</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>

                        </div>
                        <RoundedOutlinedContainer title={"ภาษาที่ใช้สัมภาษณ์"}>
                            <FormGroup className="job-position-language-flex">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={langTh}
                                            onChange={(e) => handleLanguageChange(e.target.checked, "th")}
                                            value={langTh}
                                            disabled
                                            className="job-position-language"
                                            sx={{
                                                borderRadius: "6px", // Add border-radius
                                                "& .MuiSvgIcon-root": {
                                                    borderRadius: "6px", // Apply border-radius inside the icon
                                                    border: `1px solid ${langTh ? "#4A25E1" : "#4A25E1"}`, // Border color logic
                                                    backgroundColor: langTh ? "#4A25E1" : "transparent", // Optional background color
                                                },
                                            }}
                                        />
                                    }
                                    label="ภาษาไทย"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={langEn}
                                            onChange={(e) => handleLanguageChange(e.target.checked, "en")}
                                            value={langEn}
                                            defaultChecked={langEn}
                                            disabled
                                            className="job-position-language"
                                            sx={{
                                                borderRadius: "6px", // Add border-radius
                                                "& .MuiSvgIcon-root": {
                                                    borderRadius: "6px", // Apply border-radius inside the icon
                                                    border: `1px solid ${langEn ? "#4A25E1" : "#4A25E1"}`, // Border color logic
                                                    backgroundColor: langEn ? "#4A25E1" : "transparent", // Optional background color
                                                },
                                            }}
                                        />
                                    }
                                    label="English"
                                />
                            </FormGroup>
                        </RoundedOutlinedContainer>
                        <div style={{ marginBottom: "16px" }}></div>
                        <RoundedOutlinedContainer title={"อุปกรณ์การสัมภาษณ์"}>
                            <FormGroup className="job-position-language-flex">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={requireCamera}
                                            onChange={(e) => handleHardwareChange(e.target.checked, "camera")}
                                            className="job-position-language"
                                            disabled
                                            sx={{
                                                borderRadius: "6px", // Add border-radius
                                                "& .MuiSvgIcon-root": {
                                                    borderRadius: "6px", // Apply border-radius inside the icon
                                                    border: `1px solid ${requireCamera ? "#4A25E1" : "#4A25E1"}`, // Border color logic
                                                    backgroundColor: requireCamera ? "#4A25E1" : "transparent", // Optional background color
                                                },
                                            }}
                                        />
                                    }
                                    label="เปิดกล้อง"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={requireMic}
                                            onChange={(e) => handleHardwareChange(e.target.checked, "mic")}
                                            className="job-position-language"
                                            disabled
                                            sx={{
                                                borderRadius: "6px", // Add border-radius
                                                "& .MuiSvgIcon-root": {
                                                    borderRadius: "6px", // Apply border-radius inside the icon
                                                    border: `1px solid ${requireMic ? "#4A25E1" : "#4A25E1"}`, // Border color logic
                                                    backgroundColor: requireMic ? "#4A25E1" : "transparent", // Optional background color
                                                },
                                            }}
                                        />
                                    }
                                    label="เปิดไมค์"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={recordVideo}
                                            onChange={(e) => handleHardwareChange(e.target.checked, "record_video")}
                                            className="job-position-language"
                                            sx={{
                                                borderRadius: "6px",
                                                "& .MuiSvgIcon-root": {
                                                    borderRadius: "6px",
                                                    border: `1px solid ${recordVideo ? "#4A25E1" : "#4A25E1"}`,
                                                    backgroundColor: recordVideo ? "#4A25E1" : "transparent",
                                                },
                                            }}
                                        />
                                    }
                                    label="บันทึกวิดีโอต่อข้อ"
                                />
                            </FormGroup>
                            {recordVideo && !requireCamera && (
                                <Typography variant="caption" color="warning.main" sx={{ display: "block", mt: 1 }}>
                                    การบันทึกวิดีโอต้องเปิดกล้อง — ระบบจะเปิดกล้องให้อัตโนมัติ
                                </Typography>
                            )}
                        </RoundedOutlinedContainer>
                        <div style={{ marginBottom: "16px" }}></div>
                        <RoundedOutlinedContainer title={"ประเภทคำตอบ"}>
                            <FormGroup className="job-position-language-flex">
                                <RadioGroup
                                    value={hardSkillQuestionType}
                                    onChange={(e) => {
                                        const selected = e.target.value;
                                        handleHardSkillQuestionChange(selected); // Always pass true when selected
                                    }}
                                    row // Optional: makes it horizontal
                                >
                                    <FormControlLabel
                                        value="voice"
                                        control={
                                            <Radio
                                                className="job-position-language"
                                                sx={{
                                                    borderRadius: "6px",
                                                    "& .MuiSvgIcon-root": {
                                                        borderRadius: "6px",
                                                        border: `1px solid #4A25E1`,
                                                        backgroundColor: hardSkillQuestionType == "voice" ? "#4A25E1" : "transparent",
                                                    },
                                                }}
                                            />
                                        }
                                        label="Voice mode"
                                    />
                                    <FormControlLabel
                                        value="multiple_choice"
                                        control={
                                            <Radio
                                                className="job-position-language"
                                                sx={{
                                                    borderRadius: "6px",
                                                    "& .MuiSvgIcon-root": {
                                                        borderRadius: "6px",
                                                        border: `1px solid #4A25E1`,
                                                        backgroundColor: hardSkillQuestionType == "multiple_choice" ? "#4A25E1" : "transparent",
                                                    },
                                                }}
                                            />
                                        }
                                        label="Multiple Choice"
                                    />
                                </RadioGroup>
                            </FormGroup>
                        </RoundedOutlinedContainer>
                        <div style={{ marginBottom: "16px" }}></div>

                        <div className="border-std job-position-premium-advance-control" >
                            <span className="title"></span>

                        </div>




                    </div>
                </div>
            </div>
            {/* <div className="border-std job-position-form-control">
                <div className="job-position-form-title-control">
                    <div className="job-position-dot-title"></div>
                    <span className="job-position-form-title">เลือกประเภทข้อมูลของ Candidate ที่ต้องกรอก (สำหรับ Public Link)</span>
                </div>
                <div className="job-position-premium-advance-control">
                    <div className="advance-item-control">
                        <span className="topic">Email (อีเมล)</span>
                        <div className="advance-choice-control">
                            <FontAwesomeIcon icon={faCheck} className={candidateRequire.email ? "enabled-active" : "enabled"} onClick={() => handleCandidateRequireChange(true, "email")}></FontAwesomeIcon>
                        </div>
                    </div>
                    <div className="advance-item-control">
                        <span className="topic">Firstname (ชื่อจริง)</span>
                        <div className="advance-choice-control">
                            <FontAwesomeIcon icon={faXmark} className={!candidateRequire.firstname ? "disabled-active" : "disabled"} onClick={() => handleCandidateRequireChange(false, "firstname")}></FontAwesomeIcon>
                            <FontAwesomeIcon icon={faCheck} className={candidateRequire.firstname ? "enabled-active" : "enabled"} onClick={() => handleCandidateRequireChange(true, "firstname")}></FontAwesomeIcon>
                        </div>
                    </div>
                    <div className="advance-item-control">
                        <span className="topic">Lastname (นามสกุล)</span>
                        <div className="advance-choice-control">
                            <FontAwesomeIcon icon={faXmark} className={!candidateRequire.lastname ? "disabled-active" : "disabled"} onClick={() => handleCandidateRequireChange(false, "lastname")}></FontAwesomeIcon>
                            <FontAwesomeIcon icon={faCheck} className={candidateRequire.lastname ? "enabled-active" : "enabled"} onClick={() => handleCandidateRequireChange(true, "lastname")}></FontAwesomeIcon>
                        </div>
                    </div>
                    <div className="advance-item-control">
                        <span className="topic">Resume (เรซูเม่)</span>
                        <div className="advance-choice-control">
                            <FontAwesomeIcon icon={faXmark} className={!candidateRequire.resume ? "disabled-active" : "disabled"} onClick={() => handleCandidateRequireChange(false, "resume")}></FontAwesomeIcon>
                            <FontAwesomeIcon icon={faCheck} className={candidateRequire.resume ? "enabled-active" : "enabled"} onClick={() => handleCandidateRequireChange(true, "resume")}></FontAwesomeIcon>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="border-std job-position-form-control">
                <div className="job-position-form-title-control">
                    <div className="job-position-dot-title"></div>
                                            <span className="job-position-form-title">{t('create_question.basic_job_detail.title')}</span>
                </div>
                <div className="job-position-item-flex">
                    <div className="job-position-item">
                        {autocompleteJobTitle && autocompleteJobTitle.length > 0 && (
                            <Autocomplete
                                id="free-solo-demo"
                                freeSolo
                                value={jobTitle}
                                onInputChange={(e, newValue) => handleJobRoleChange(e, newValue)}
                                className={isSubmitting && isError.jobTitle ? "input-std job-position-item-input-field input-error" : "input-std job-position-item-input-field"}
                                options={autocompleteJobTitle}
                                renderOption={(props, option) => (
                                    <li {...props} className="autocomplete-option-custom">
                                        {option}
                                    </li>
                                )}
                                renderInput={(params) => <TextField {...params} label="Job Title*" />}
                            />

                        )}
                    </div>
                </div>
                <div className="job-position-item-grid">

                    <div className="job-position-item">

                        {industryList && industryList.length > 0 && (

                            <Autocomplete
                                id="free-solo-demo"
                                freeSolo
                                onInputChange={(event, value) => handleIndustryChange(value)}
                                className='input-std job-position-item-input-field'
                                options={industryList}
                                value={industryValue}
                                renderOption={(props, option) => (
                                    <li {...props} className="autocomplete-option-custom">
                                        {option}
                                    </li>
                                )}
                                renderInput={(params) => <TextField {...params} label="Industry *" />}
                            />

                        )}
                    </div>
                    <div className="job-position-item">

                        {departmentList && departmentList.length > 0 && (

                            <Autocomplete
                                id="free-solo-demo"
                                freeSolo
                                onInputChange={(event, value) => handleDepartmentChange(value)}
                                className='input-std job-position-item-input-field'
                                options={departmentList}
                                value={departmentValue}
                                renderOption={(props, option) => (
                                    <li {...props} className="autocomplete-option-custom">
                                        {option}
                                    </li>
                                )}
                                renderInput={(params) => <TextField {...params} label="Department *" />}
                            />

                        )}
                    </div>
                    <div className="job-position-item">
                        <FormControl className="input-std" fullWidth>
                            <InputLabel id="demo-simple-select-label">{t('create_question.basic_job_detail.job_employment')}</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={jobEmployment}
                                label="Job Employment"
                                className="job-position-item-input-field"
                                defaultValue={jobEmployment}
                                onChange={(e) => handleChangeEmploymentType(e.target.value)}
                            >
                                <MenuItem value="Full Time">Full Time (ประจำ)</MenuItem>
                                <MenuItem value="Part Time">Part Time (พาทไทม์)</MenuItem>
                                <MenuItem value="Contract">Contract (สัญญาจ้าง)</MenuItem>
                                <MenuItem value="Internship">Internship (ฝึกงาน)</MenuItem>
                            </Select>
                        </FormControl>

                    </div>
                    <div className="job-position-item">
                        <FormControl className="input-std" fullWidth>
                            <InputLabel id="demo-simple-select-label">{t('create_question.basic_job_detail.job_level')}</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={level}
                                label="Job Employment"
                                className="job-position-item-input-field"
                                defaultValue={level}
                                onChange={(e) => handleChangeLevel(e.target.value)}
                            >
                                <MenuItem value="Entry-Level">Entry Level</MenuItem>
                                <MenuItem value="Mid-Level">Mid Level</MenuItem>
                                <MenuItem value="Senior Level">Senior</MenuItem>
                                <MenuItem value="Executive Level">Executive</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="job-position-item">
                        <FormControl className="input-std" fullWidth>
                            <InputLabel id="demo-simple-select-label">{t('create_question.basic_job_detail.job_work_type')}</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={jobWorkType}
                                label="Job Employment"
                                className="job-position-item-input-field"
                                defaultValue={jobWorkType}
                                onChange={(e) => handleChangeWorkType(e.target.value)}
                            >
                                <MenuItem value="Onsite">Onsite</MenuItem>
                                <MenuItem value="Remote">Remote / WFH</MenuItem>
                                <MenuItem value="Hybrid">Hybrid</MenuItem>
                            </Select>
                        </FormControl>
                    </div>


                </div>
            </div>
            <div className="border-std job-position-form-control">
                <div className="job-position-form-title-control">
                    <div className="job-position-dot-title"></div>
                    <span className="job-position-form-title">{t('create_question.experience_and_skill.title')}</span>
                </div>
                <div className="job-position-item-grid">
                    <div className="job-position-item">
                        <span className="job-position-item-label">{t('create_question.experience_and_skill.year_exp')}</span>
                        <div className="job-position-item-input-field-slider">
                            <Slider
                                className="job-position-item-input-slider"
                                value={jobExp}
                                onChange={handleChangeExp}
                                valueLabelDisplay="on"
                                marks={jobEXPRange}
                                min={0}
                                max={10}
                                step={1} // 🔹 Step of 1 year
                                getAriaValueText={valuetext}
                            />
                        </div>
                    </div>
                    <div className="job-position-item">
                        <span className="job-position-item-label">{t('create_question.experience_and_skill.job_salary')}</span>
                        <div className="job-position-item-input-field-slider-2">
                            <Slider
                                className="job-position-item-input-slider"
                                value={jobSalary}
                                onChange={handleChangeSalary}
                                valueLabelDisplay="on"
                                marks={salaryRange}
                                min={15000}
                                max={100000}
                                step={5000} // 🔹 Step of 1 year
                                getAriaValueText={valuetextSalary}
                            />
                        </div>
                    </div>


                </div>


            </div>
            <div className="border-std job-position-form-control">
                <div className="job-position-form-title-control">
                    <div className="job-position-dot-title"></div>
                    <span className="job-position-form-title">{t('create_question.job_specific_information.title')}</span>
                    <div className="button-std job-position-ai-button" onClick={generateJD}>
                        <img src={AI_STAR} className="job-position-ai-button-icon"></img>
                        <span className="job-position-ai-button-label">กรอกข้อมูลอัตโนมัติด้วย AI</span>
                    </div>
                </div>
                <div className="job-position-item-flex">
                    <div className="job-position-item">

                        {
                            aiGenerating ?
                                <div className="job-position-loading-ai-gen">
                                    <div className="job-position-loading-ai-item-control">
                                        <img src={AI_STAR} className="job-position-loading-ai-item-icon"></img>
                                        <span className="job-position-loading-ai-item-desc">generating job description...</span>
                                    </div>
                                </div> :
                                <FormControl className={isSubmitting && isError.jobDescription ? "input-std job-position-item-input-field-textarea input-error" : "input-std job-position-item-input-field-textarea"} fullWidth>
                                    <TextField id="outlined-basic" label="Job Description"
                                        variant="outlined"
                                        value={jobDescription}
                                        rows={8}
                                        multiline
                                        onChange={(e) => handleInputChange(e, 'jobDescription')} />
                                </FormControl>

                        }


                    </div>
                </div>
                {
                    !aiGenerating &&
                    <>
                        <div className="job-position-item-flex">
                            <div className="job-position-item">
                                <FormControl className="input-std job-position-item-input-field-textarea" fullWidth>
                                    <TextField id="outlined-basic" label={t('create_question.job_specific_information.job_qualification')}
                                        variant="outlined"
                                        value={jobQualification}
                                        rows={8}
                                        multiline
                                        onChange={(e) => handleInputChange(e, 'jobResponsibility')}></TextField>
                                </FormControl>

                            </div>
                        </div>
                        <div className="job-position-item-flex">
                            <div className="job-position-item">
                                {
                                    allSoftSkills && allSoftSkills.length > 0 &&
                                    <ChipSelector isError={isSubmitting && isError.softSkill ? isError.softSkill : false}
                                        label={"Soft Skills*"}
                                        selectedSkills={selectedSoftSkills}
                                        skills={allSoftSkills}
                                        setSkills={handleChipChange}></ChipSelector>
                                }

                            </div>
                        </div>
                        <div className="job-position-item-flex">
                            <div className="job-position-item">
                                {
                                    allSkills && allSkills.length > 0 &&
                                    <ChipSelector
                                        isError={isSubmitting && isError.hardSkill ? isError.hardSkill : false}
                                        label={"Hard Skills*"}
                                        selectedSkills={selectedHardSkills} skills={allSkills}
                                        setSkills={handleChipChange}></ChipSelector>
                                }

                            </div>
                        </div>
                        <div className="job-position-item-flex">
                            <div className="job-position-item">
                            {
                                selectedToolTech && selectedToolTech.length > 0 && 
                                 <ChipSelector isError={false} label={"Tech Tool"}
                                    selectedSkills={selectedToolTech} skills={allSkills}
                                    setSkills={handleChipChange}></ChipSelector>
                            }
                               

                            </div>
                        </div>
                        <div style={{ marginTop: '16px' }}></div>
                        <div className="job-position-form-title-control">
                            <div className="job-position-dot-title"></div>
                            <span className="job-position-form-title">{t('create_question.culture.title')}</span>
                        </div>


                        <div className="job-position-item-flex">
                            <div className="job-position-item">
                                <ChipSelector isError={false} label={"Culture"}
                                    selectedSkills={selectedCompCulture} skills={allSkills}
                                    setSkills={handleChipChange}></ChipSelector>
                            </div>

                        </div>

                        <div className="job-position-item-flex">
                            <div className="job-position-item">
                                <ChipSelector isError={false} label={"Leadership"}
                                    selectedSkills={selectedLeaderShip} skills={allSkills}
                                    setSkills={handleChipChange}></ChipSelector>
                            </div>

                        </div>
                    </>
                }



            </div>
        </div>
    );
};

export default JobPositionComponent;
